<template>
  <StepContainer :stepList="stepList" @update:step="handleUpdateStep"/>
</template>

<script setup>
import StepContainer from "../components/StepContainer.vue";
import StepCandidateCreate1 from "../components/StepCandidateCreate1.vue";
import StepCandidateCreate2 from "../components/StepCandidateCreate2.vue";
import StepCandidateCreate3 from "../components/StepCandidateCreate3.vue";
import StepCandidateCreate4 from "../components/StepCandidateCreate4.vue";
import StepCandidateCreate5 from "../components/StepCandidateCreate5.vue";
import StepCandidateCreate6 from "../components/StepCandidateCreate6.vue";
import {useReferrerQueryParams} from "../composables/ReferrerQueryParams.js";
import {useCandidateAccountCreateStore} from "../stores/CandidateAccountCreateStore.js";
import {redirectToDashboardIfAuthenticated} from "../helpers/Redirects.js";
import {useRouter} from "vue-router";
import {watch} from "vue";

const stepList = [
  StepCandidateCreate1,
  StepCandidateCreate2,
  StepCandidateCreate3,
  StepCandidateCreate4,
  StepCandidateCreate5,
  StepCandidateCreate6,
];

const emits = defineEmits(["account-created"]);
const router = useRouter();
const referrerHandler = useReferrerQueryParams();
const store = useCandidateAccountCreateStore();

const handleUpdateStep = (stepNumber) => {
  if (stepNumber >= stepList.length - 1) {
    emits("account-created");
  }
};

redirectToDashboardIfAuthenticated(router);

watch(() => referrerHandler.referrerCode, (newVal) => {
  if (!newVal.value) return;
  store.referralCode = newVal.value;
}, {immediate: true});
</script>
